// extracted by mini-css-extract-plugin
module.exports = {"LinerShape":"TheSeparator_LinerShape__1Xu7O","KeepDistance":"TheSeparator_KeepDistance__1c8hh"};